import { Box, Skeleton } from '@mui/material';

function SelectFilesSkeleton() {
  return (
    <Box display="flex" alignItems="center">
      <Skeleton variant="rounded" sx={{ width: 125, height: 80, mr: 1 }} />
      <Skeleton variant="rounded" sx={{ width: 125, height: 80, mr: 1 }} />
      <Skeleton variant="rounded" sx={{ width: 125, height: 80, mr: 1 }} />
    </Box>
  );
}

export default SelectFilesSkeleton;
